import classnames from 'classnames'

import Button from 'components/Button'
import Image from 'components/Image'
import Link from 'components/Link'
import Paragraph from 'components/Paragraph'

import asyncComponent from 'utils/asyncComponent'

import { useMobileDetect } from 'hooks/mobileDetect'

import Styled from './styled'

const Carousel = asyncComponent(() => import('components/Carousel'))

export default function SectionPromotion({ data }) {
  const { isMobile } = useMobileDetect()

  const title = data?.title
  const promotions = data?.promotions
  const buttonText = data?.button?.title || 'ดูโปรโมชั่นทั้งหมด'
  const link = data?.button?.url || '/voucher'

  return (
    <Styled>
      <Paragraph className="title font-semibold">{title}</Paragraph>

      <div className="promotion-block">
        <Carousel
          options={{
            autoplay: {
              delay: 8000,
            },
          }}
          items={promotions}
          uiRenderer={item => {
            const image = item?.image?.url
            const altDesktopImage = item?.image?.alternativeText
            const mobileImage = item?.mobileImage?.url
            const altMobileImage = item?.mobileImage?.alternativeText
            const link = item?.url
            return (
              <div className="promotion-image-block">
                <Link href={link}>
                  {isMobile ? (
                    <div className={classnames('image mobile', { 'img-mobile': mobileImage })}>
                      <Image src={mobileImage || image} imgixWidth={900} alt={altMobileImage} />
                    </div>
                  ) : (
                    <Image
                      src={image}
                      className="image-desktop"
                      imgixWidth={1920}
                      alt={altDesktopImage}
                    />
                  )}
                </Link>
              </div>
            )
          }}
        />
      </div>

      <div className="promotion-button-block">
        <Link href={link} openNewTab>
          <Button dynamic type="ghost">
            {buttonText}
          </Button>
        </Link>
      </div>
    </Styled>
  )
}
